import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import { Person } from 'nekst-api';
import { ClientAppToggleWrapper } from 'feature-toggle';
import { TextBadge, TextBadgeVariant } from 'features/nekst-widgets';

export function ClientAppIndicatorFieldImpl() {
  const showContext = useShowContextRequired<Person>();
  const person = showContext.data;

  const isServiceProvider = person._serviceProviders.length > 0;
  const isSharedInClientApp = person.isSharedInClientApp === true;

  if (isServiceProvider && isSharedInClientApp) {
    return (
      <TextBadge
        text="Client App"
        variant={TextBadgeVariant.PRIMARY}
        isSmall
        title="This service provider is visible in the Client App"
      />
    );
  }

  return null;
}

export function ClientAppIndicatorField() {
  return (
    <ClientAppToggleWrapper>
      <ClientAppIndicatorFieldImpl />
    </ClientAppToggleWrapper>
  );
}
